import { connect } from 'react-redux'
import { pageView } from '../actions/analytics'
import Home from '../components/Home'

const mapDispatchToProps = {
  pageView
}

export default connect(
  null,
  mapDispatchToProps
)(Home)


// WEBPACK FOOTER //
// ./src/containers/Home.js